import { render } from "./MainCategories.vue?vue&type=template&id=9488b826&scoped=true"
import script from "./MainCategories.vue?vue&type=script&lang=js"
export * from "./MainCategories.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9488b826"

export default script